import React, { useEffect, useState } from "react";

//Hooks
import useGetFuenteOferta from "../Hooks/useGetFuenteOferta";

//Componentes de Material UI
import {
    TextField,
    MenuItem,
    Box,
    CircularProgress,
    Alert,
    AlertTitle,
    IconButton,
    Tooltip,
} from "@mui/material";

//Iconos
import { Refresh as RefreshIcon } from "@mui/icons-material";

const SelectFuenteOferta = ({
    label,
    name,
    value,
    onChange,
    error,
    helperText,
    disabled,
    required
}) => {
    const { data, refreshGetData } = useGetFuenteOferta({ autoload: true });
    const [btIgual, setBtIgual] = useState(true)

    useEffect(() => {
        let btValueSame
        if (data && value) {
            btValueSame = data?.some(e => e.strCodigo === "FuenteOfertaLaboral" && e.strCodigoRetorno === value)
            setBtIgual(btValueSame)
        }
    }, [data])

    if (data === undefined) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (data === null) {
        return (
            <Alert
                severity="info"
                action={
                    <IconButton
                        onClick={() => {
                            refreshGetData();
                        }}
                    >
                        <Tooltip title="Refrescar">
                            <RefreshIcon />
                        </Tooltip>
                    </IconButton>
                }
            >
                <AlertTitle>
                    <b>Sin datos</b>
                </AlertTitle>
                No existen datos de las sedes de Choucair.
            </Alert>
        );
    }

    if (data.error) {
        return (
            <Alert
                severity="error"
                action={
                    <IconButton
                        onClick={() => {
                            refreshGetData();
                        }}
                    >
                        <Tooltip title="Refrescar">
                            <RefreshIcon />
                        </Tooltip>
                    </IconButton>
                }
            >
                <AlertTitle>
                    <b>{data.msg}</b>
                </AlertTitle>
                Ha ocurrido un error al obtener las sedes de Choucair.
            </Alert>
        );
    }

    return (
        <TextField
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            helperText={helperText}
            error={error}
            disabled={disabled}
            required={required}
            fullWidth
            select
        >
            {data.map((e, i) => (
                <MenuItem value={!btIgual ? value : e.strCodigoRetorno} key={i}>
                    {!btIgual ? value : e.strCodigoRetorno}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default SelectFuenteOferta;